Pixlee.module('Behaviors', function(Behaviors, App, Backbone, Marionette, $) {

    Behaviors.SubmitPhotos = Marionette.Behavior.extend({
        ui: {
            submitContent: '#submit_content',
            dragDropTitle: '#drag_drop_form'
        },
        onShow: function() {
            this.ui.submitContent.one('click', this, this.submitValidation);
        },
        submitValidation: function(ev) {
            var _this = ev.data;

            var requiredFields = _this.$el.find('.required');
            var success = true;

            $.each(requiredFields, function(index, field) {
                var photoHolder = $(field).parent();
                if (_.isFalsy(field.value)) {
                    success = false;
                    photoHolder.addClass('error');
                } else {
                    photoHolder.removeClass('error');
                }
            });

            if (success) {
                _this[_this.view.options.source + 'Submit']();
                _this.view.triggerMethod('submit');
            } else {
                _this.ui.submitContent.one('click', _this, _this.submitValidation);
            }
        },
        instagramSubmit: function() {
            var collection, current_album = App.request('get:current:album'),
                obj;
            var models = this.view.collection.models;
            collection = this.createPhotoCollection(models);
            obj = this.createPhotoObj(this.view.connectedUser.toJSON(), collection, 'instagram', current_album.get('id'));
            this.submitPhotos(obj, this);
        },
        facebookSubmit: function() {
            var _this = this;
            var current_album = App.request('get:current:album');
            var collection, obj;
            var models = this.view.collection.models;
            collection = this.createPhotoCollection(models);
            obj = this.createPhotoObj(this.view.connectedUser.toJSON(), collection, 'facebook', current_album.get('id'));
            this.submitPhotos(obj, this);
        },
        desktopSubmit: function() {
            var config = App.config.toJSON();
            var currentUser = App.currentUser.toJSON();
            var collection = this.view.collection.models;
            var createUrl = config.distilleryUrl + 'inbound/v1/create_cp?api_key=' + currentUser.single_access_token + '&time_stamp=' + Date.now();
            var _this = this;
            var obj;

            for (var i = 0; i < collection.length; i++) {
                var model = collection[i];
                var name = '#file_' + model.get('uid');
                var album_id = App.request('get:current:album').get('id');

                model.set('album_id', album_id);

                //need to change this
                obj = {
                    album_id: album_id,
                    title: !_.isFalsy(model.get('caption')) ? model.get('caption') : null,
                    email: this.view.model.get('email_address'),
                    username: this.view.model.get('full_name'),
                    connected_user: this.view.connectedUser.toJSON()
                };

                $.ajax({
                    type: 'POST',
                    url: createUrl,
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify(obj),
                    success: _this.successCallback,
                    context: {
                        model: model
                    }
                });
            }
        },
        successCallback: function(data) {
            var files = this.model.get('files');
            var fileName = App.request('decode:utf8', files[0].name).replace(/[\`\'\'\(\)\/\+\%]/gi, '_');
            var key = data.path + fileName;

            this.model.set('photoId', data.album_photo_id);
            files[0].fileKey = key;
            var form;
            if (!_.isFalsy(this.model.attributes.form) && !_.isFalsy(this.model.attributes.form.length)) {
                form = this.model.attributes.form;
            } else {
                form = $('#drag_drop_form');
            }
            if (window.console) {
                console.log('this.model.attributes.form ' + this.model.toJSON());
                console.log('$(#drag_drop_form).length ' + $('#drag_drop_form').length);
                // console.log('this.model.attributes.form.length ' + this.model.attributes.form.length);
                console.log('form.length ' + form.length);
                console.log('$("#drag_drop_form").find("input[name=key]").length ' + form.find('input[name=key]').length);
            }
            form.find('input[name=key]').val(key);
            if (window.console) {
                console.log('key');
                console.log(key);
                console.log(form.find('input[name=key]').val());
            }
            form.find('input[name=Filename]').val(fileName);
            if (window.console) {
                console.log('Filename');
                console.log(fileName);
                console.log(form.find('input[name=Filename]').val());
            }
            form.find('input[name=policy]').val(data.encoded_policy);
            if (window.console) {
                console.log('policy');
                console.log(data.encoded_policy);
                console.log(form.find('input[name=policy]').val());
            }
            form.find('input[name=signature]').val(data.signature);
            if (window.console) {
                console.log('signature');
                console.log(data.signature);
                console.log(form.find('input[name=signature]').val());
            }
            form.find('input[name=AWSAccessKeyId]').val(data.access_key || 'AKIATNG6EAYVBK6T77BU');
            if (window.console) {
                console.log('AWSAccessKeyId');
                console.log(data.access_key);
                console.log(form.find('input[name=AWSAccessKeyId]').val());
            }
            form.find('input[name=Content-Type]').val(files[0].type);
            if (window.console) {
                console.log('Content-Type');
                console.log(files[0].type);
                console.log(form.find('input[name=Content-Type]').val());
            }

            this.model.attributes.submit();
        },
        createPhotoCollection: function(models) {
            var collection = [];

            for (var i = 0; i < models.length; i++) {
                var currentModel = models[i];
                var currentCaption = !_.isFalsy(currentModel.get('caption')) ? currentModel.get('caption') : '';
                collection.push({
                    'id': currentModel.get('id'),
                    'type': currentModel.get('type'),
                    'caption': App.request('encode:utf8', currentCaption),
                    'extra_data': currentModel.get('extra_data')
                });
            }
            return collection;

        },
        createPhotoObj: function(user, collection, source, albumId) {
            var obj = {
                connectedUser: JSON.stringify(user),
                collection: JSON.stringify(collection),
                source: source,
                album_id: albumId
            };
            return obj;
        },
        submitPhotos: function(obj, view) {
            var _this = this;
            $.ajax({
                type: 'POST',
                url: '/uploadSocial',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(obj),
                success: function() {
                    if (App.request('get:current:album').get('id') == 147890) {
                        var thankYouUrl_input;
                        thankYouUrl_input = App.displayOptions.get('thankYouUrl_input');
                        if (!_.isFalsy(thankYouUrl_input)) {
                            thankYouUrl_input = thankYouUrl_input + _this.view.connectedUser.get('full_name') + '&email=' + _this.view.connectedUser.get('email_address');
                            window.top.location = thankYouUrl_input;
                        }
                    } else {
                        _this.view.trigger('show:confirm:panel');
                    }
                }
            });
        }
    });

});
